import { createModel } from '@rematch/core'
// import * as faker from 'faker'
import * as firebase from 'firebase'
import { select, store } from '../store'

interface IUserState {
  [userId: string]: IUser
}

async function fetchUser(userId: string) {
  const ref = await firebase
    .firestore()
    .collection('users')
    .doc(userId)
    .get()
  const user = ref.data()
  if (user) {
    return user as IUser
  } else {
    throw Error('Cannot fetch user')
  }
}

export default createModel({
  state: {} as IUserState,
  reducers: {
    updateById: (
      state: IUserState,
      payload: { userId: string; user: IUser }
    ): IUserState => ({
      ...state,
      [payload.userId]: payload.user
    })
  },
  effects: {
    async fetchUsers(userIds: string[]) {
      userIds.map(userId => {
        fetchUser(userId)
          .then(user => this.updateById({ userId, user }))
          .catch(err => {
            const errorUser: IUser = {
              userName: 'N/A',
              fullName: 'N/A',
              email: 'N/A',
              title: null,
              description: null,
              photoURL: null,
              jobs: []
            }
            this.updateById({ userId, user: errorUser })
          })
      })
    },
    async updateProfile(updated: Partial<IUser>) {
      const rootState = store.getState()
      const currentUser = firebase.auth().currentUser
      if (currentUser) {
        const userId = currentUser.uid
        const user = select.users.getById(rootState, userId)
        firebase
          .firestore()
          .collection('users')
          .doc(userId)
          .update(updated)
          .then((_: any) =>
            this.updateById({ userId, user: { ...user, ...updated } })
          )
      }
    }
  },
  selectors: {
    getById: (state: IUserState, userId: string) => {
      return state[userId] ? state[userId] : null
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/users.ts